import axios from "axios";

import type { TUpdateUserRequestData } from "@/modules/shared/types/user";

const userApi = {
  updateUser: (initData: string, data: TUpdateUserRequestData) =>
    axios({
      method: "POST",
      url: "/user/me",
      data: data,
      headers: {
        "Init-Data": initData,
        "Content-Type": "application/json",
      },
    }),
  getUserContributor: (
    initData: string,
    count: number = 25,
    offset: number = 0,
  ) =>
    axios({
      method: "GET",
      url: "/user/contributors",
      params: {
        offset,
        count,
      },
      headers: {
        "Init-Data": initData,
        "Content-Type": "application/json",
      },
    }),
  getUserRepDetails: (initData: string) =>
    axios({
      method: "GET",
      url: "/user/rep-details",
      headers: {
        "Init-Data": initData,
        "Content-Type": "application/json",
      },
    }),
  deleteUser: (userId: string | number) =>
    axios({
      method: "DELETE",
      url: "/test/delete-user",
      params: {
        userId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }),
  addReferrals: (userId: string | number) =>
    axios({
      method: "GET",
      url: "/test/add-referrals",
      params: {
        userId,
        referralCount: 50,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }),
};

export { userApi };
